import { deleteCampaignService } from "../infrastructure/services/deleteCampaignService";
import { tokenValidation } from "@/business/auth/application/tokenValidation";

export const deleteCampaign = {
    async execute(name: string): Promise<void> {
        await deleteCampaignService.execute(await tokenValidation.execute(), name);
    },
};

